import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import "../styles/toolStyling/Reveal.css";

// Parent container variants with staggerChildren
// When 'visible', children animate one after another.
const containerVariants = {
  hidden: { opacity: 1 }, // Keep parent visible to avoid layout shift
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3, // Delay between children
      delayChildren: 0.1, // Initial delay before first child animates
    },
  },
};

export function RevealGroup({ children }) {
  const control = useAnimation();

  // Using a low threshold so animation starts when section just begins to appear
  const [ref, inView] = useInView({
    threshold: 0.3, //// 30% of the element must be visible before triggering
    triggerOnce: true, // or true if you only want it once
    rootMargin: "-100px 0px", // triggers 100px later than normal
  });

  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
    // By adding this else condition, we ensure that the animation
    // takes place every time the component is in view. We can comment
    // the else condition if we want to run the animation once.
    else {
      control.start("hidden");
    }
  }, [inView, control]);

  return (
    <motion.div
      ref={ref}
      variants={containerVariants}
      initial="hidden"
      animate={control}
      className="reveal-group"
    >
      {children}
    </motion.div>
  );
}
